
const roleRoutes = [
    {
        path:'list',
        name:'role-list',
        component: () => import(/* webpackChunkName: "about" */ '../views/role/list.vue')
    },
]
export default roleRoutes